"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _Basic = _interopRequireDefault(require("./templates/Basic"));
var _TswBasic = _interopRequireDefault(require("./templates/TswBasic"));
var _Video = _interopRequireDefault(require("./templates/Video"));
var _SVGContent = _interopRequireDefault(require("./templates/SVGContent"));
var _constants = require("../constants");
var templates = {
  Basic: _Basic["default"],
  TswBasic: _TswBasic["default"],
  Video: _Video["default"],
  SVGContent: _SVGContent["default"]
};
var Hero = function Hero(props) {
  var _useInView = (0, _reactIntersectionObserver.useInView)({
      rootMargin: _constants.LAZY_LOAD_OFFSET,
      triggerOnce: true
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  var TemplateSelected = templates[props.template];
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: "d8-c-hero ".concat(props.fullHeight && 'hero--full-height')
  }, /*#__PURE__*/_react["default"].createElement(TemplateSelected, (0, _extends2["default"])({}, props, {
    inView: inView
  })));
};
Hero.propTypes = {
  template: _propTypes["default"].string,
  fullHeight: _propTypes["default"].bool
};
Hero.defaultProps = {
  template: 'Basic'
};
var _default = exports["default"] = Hero;